export const config = {
    NETWORK_URL: "https://api-test.ncogchain.earth",
    DOMAIN: "securus.co",
    BASE_URL: "https://api.securus.co",
    GOOGLE_CLIENT_ID: "694201110231-andbd6j8bfm9fsdcejrk90g07jg1p23t.apps.googleusercontent.com",
    FACEBOOK_APP_ID: "404824635623953",
    TERMS_CONDITIONS_URL: "https://securus.co/termsOfService.html",
    PRIVACY_POLICY_URL: "https://securus.co/privacyPolicy.html"
}
